import * as tslib_1 from "tslib";
import { OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RedeemService } from '../redeem.service';
import { SharedService } from '../../shared/shared.service';
import { LoaderService } from '../../loader.service';
import { AuthService } from '../../auth.service';
import { ToasterService } from '../../toaster.service';
import { Toaster, ToasterType } from '../../shared/types/toaster.types';
import { WEEK_DAYS, TRANSACTION_PERIODS, VARIABLE_LIST, OPERATOR_LIST, BOOLEAN_VALUES } from '../redeem.types';
import { LIST_REDEEMS } from '../../routes';
var RedeemCreateComponent = /** @class */ (function () {
    function RedeemCreateComponent(redeemService, sharedService, loaderService, authService, toasterService, router, route) {
        this.redeemService = redeemService;
        this.sharedService = sharedService;
        this.loaderService = loaderService;
        this.authService = authService;
        this.toasterService = toasterService;
        this.router = router;
        this.route = route;
        this.actionTitle = 'Add';
        this.isEdit = false;
        this.ruleId = null;
        this.rule = {};
        this.cities = [];
        this.modes = [];
        this.shifts = [];
        this.selectedCity = null;
        this.selectedMode = null;
        this.weekDays = WEEK_DAYS;
        this.transactionPeriods = TRANSACTION_PERIODS;
        this.variableList = VARIABLE_LIST;
        this.operatorList = OPERATOR_LIST;
        this.booleanValues = BOOLEAN_VALUES;
        this.disableSubmit = false;
        this.maxLimits = {};
        this.blockRedeem = false;
        this.startDateInput = null;
        // Auto-approval rule builder state (mirrors the legacy controller).
        this.multiAutoRulesSet = {};
        this.generatedRule = {};
        this.setCount = 0;
        this.newRuleGenerated = false;
        this.tempRules = {};
        // City -> Modes (same as the create-shift flow). Cities are stored as displayName strings.
        this.compareModeById = function (a, b) {
            if (!a || !b) {
                return a === b;
            }
            return String(a.id) === String(b.id);
        };
    }
    RedeemCreateComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var requiredPermission, permissions;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.ruleId = this.route.snapshot.paramMap.get('id');
                        this.isEdit = !!this.ruleId;
                        this.actionTitle = this.isEdit ? 'Edit' : 'Add';
                        requiredPermission = this.isEdit ? 'redeem_edit' : 'redeem_add';
                        return [4 /*yield*/, this.authService.getPermissions()];
                    case 1:
                        permissions = _a.sent();
                        if (!permissions || permissions.indexOf(requiredPermission) < 0) {
                            this.errorMessage('You are not authorized to access this page');
                            this.router.navigate(['/']);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.withLoader(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.fetchDashboardConfig()];
                                        case 1:
                                            _a.sent();
                                            return [4 /*yield*/, this.fetchCities()];
                                        case 2:
                                            _a.sent();
                                            if (!this.isEdit) return [3 /*break*/, 4];
                                            return [4 /*yield*/, this.getRuleDetails(this.ruleId)];
                                        case 3:
                                            _a.sent();
                                            return [3 /*break*/, 6];
                                        case 4: return [4 /*yield*/, this.applyLaunchQueryPrefill()];
                                        case 5:
                                            _a.sent();
                                            _a.label = 6;
                                        case 6: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Prefill create form from CSCC
    RedeemCreateComponent.prototype.applyLaunchQueryPrefill = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var q, cityId, modeId, city, mode;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        q = this.route.snapshot.queryParams || {};
                        cityId = (q['city'] || '').trim();
                        modeId = (q['mode'] || '').trim();
                        if (!cityId) {
                            return [2 /*return*/];
                        }
                        city = this.cities.find(function (c) { return String(c.id) === String(cityId); });
                        if (!city) {
                            return [2 /*return*/];
                        }
                        this.selectedCity = city;
                        return [4 /*yield*/, this.onCityChange(city)];
                    case 1:
                        _a.sent();
                        if (!modeId) {
                            this.errorMessage('Mode is required in launch URL.');
                            return [2 /*return*/];
                        }
                        mode = this.modes.find(function (m) { return String(m.id) === String(modeId); });
                        if (!mode) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.onModeChange(mode)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.errorMessage('Invalid mode in launch URL for the selected city.');
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RedeemCreateComponent.prototype.withLoader = function (cb) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, , 2, 3]);
                        this.loaderService.openLoading();
                        return [4 /*yield*/, cb()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        this.loaderService.closeLoading();
                        return [7 /*endfinally*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RedeemCreateComponent.prototype.fetchDashboardConfig = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.sharedService.fetchDashboardConfig().toPromise()];
                    case 1:
                        res = _a.sent();
                        this.maxLimits = (res && res.data && res.data.redeemRulesMaxLimits) || {};
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        this.maxLimits = {};
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RedeemCreateComponent.prototype.fetchCities = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sharedService.fetchCities().toPromise()];
                    case 1:
                        res = _a.sent();
                        this.cities = (res.data.cities || [])
                            .filter(function (c) { return c.active; })
                            .map(function (c) { return ({ id: c._id, name: c.displayName }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    RedeemCreateComponent.prototype.onCityChange = function (city) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.selectedMode = null;
                        this.modes = [];
                        this.shifts = [];
                        this.rule.shift = [];
                        this.blockRedeem = false;
                        if (!city) {
                            this.rule.cities = [];
                            return [2 /*return*/];
                        }
                        this.rule.cities = [city.name];
                        return [4 /*yield*/, this.fetchModesForCity(city.id)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RedeemCreateComponent.prototype.fetchModesForCity = function (cityId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res, err_2;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!cityId) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.withLoader(function () { return _this.sharedService.fetchModes(cityId).toPromise(); })];
                    case 2:
                        res = _a.sent();
                        this.modes = (res && res.data && res.data.modes) || [];
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        this.modes = [];
                        this.errorMessage('Error fetching modes');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // Mode selected -> fetch shifts for the city+mode combination from captain-earnings (/api/v1/shifts).
    RedeemCreateComponent.prototype.onModeChange = function (mode) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.selectedMode = mode;
                        this.shifts = [];
                        this.rule.shift = [];
                        this.blockRedeem = false;
                        if (!(this.selectedCity && mode)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchCaptainShifts(this.selectedCity.id, mode.id)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    RedeemCreateComponent.prototype.fetchCaptainShifts = function (cityId, modeId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res, arr, names, merged, err_3;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!cityId || !modeId) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.withLoader(function () {
                                return _this.sharedService.fetchCaptainEarningsShifts(cityId, modeId, false).toPromise();
                            })];
                    case 2:
                        res = _a.sent();
                        arr = [];
                        if (res && res.data && res.data.shifts && Array.isArray(res.data.shifts)) {
                            arr = res.data.shifts;
                        }
                        else if (res && res.data && Array.isArray(res.data)) {
                            arr = res.data;
                        }
                        else if (Array.isArray(res)) {
                            arr = res;
                        }
                        names = arr
                            .map(function (s) { return (typeof s === 'object' && s !== null) ? (s.name || '') : String(s); })
                            .filter(function (name) { return name.trim() !== ''; });
                        merged = new Set((this.rule.shift || []).concat(names));
                        this.shifts = Array.from(merged);
                        return [3 /*break*/, 4];
                    case 3:
                        err_3 = _a.sent();
                        this.errorMessage('Error fetching shifts');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(RedeemCreateComponent.prototype, "isShiftScoped", {
        get: function () {
            return !!(this.selectedCity && this.selectedMode && this.rule.shift && this.rule.shift.length > 0);
        },
        enumerable: true,
        configurable: true
    });
    RedeemCreateComponent.prototype.onShiftChange = function () {
        if (this.blockRedeem) {
            if (this.isShiftScoped) {
                this.rule.tnc = this.blockRedeemTnc();
            }
            else {
                this.blockRedeem = false;
            }
        }
    };
    RedeemCreateComponent.prototype.onBlockRedeemChange = function () {
        if (this.blockRedeem) {
            this.applyBlockRedeemDefaults();
        }
    };
    RedeemCreateComponent.prototype.blockRedeemTnc = function () {
        var shiftLabel = (this.rule.shift || []).join(', ');
        return shiftLabel ? "Redeem is blocked for shift " + shiftLabel + "." : 'Redeem is blocked for this shift.';
    };
    RedeemCreateComponent.prototype.applyBlockRedeemDefaults = function () {
        this.rule.transactionCount = 0;
        this.rule.weekDays = WEEK_DAYS.slice();
        this.rule.transactionPeriod = TRANSACTION_PERIODS[0];
        this.rule.minTransactionAmount = 1;
        this.rule.startDate = this.today;
        this.rule.firstRedeemMinAmount = undefined;
        this.rule.tnc = this.blockRedeemTnc();
        this.multiAutoRulesSet = {};
        this.setCount = 0;
    };
    RedeemCreateComponent.prototype.openStartDatePicker = function () {
        var el = this.startDateInput ? this.startDateInput.nativeElement : null;
        if (!el) {
            return;
        }
        var input = el;
        if (typeof input.showPicker === 'function') {
            input.showPicker();
        }
        else {
            el.focus();
            el.click();
        }
    };
    // ---- Auto-approval rule builder (ported verbatim from legacy) ----
    // Ordered set keys for template iteration (keys are sequential numeric strings).
    RedeemCreateComponent.prototype.ruleSetKeys = function () {
        return Object.keys(this.multiAutoRulesSet).sort(function (a, b) { return Number(a) - Number(b); });
    };
    RedeemCreateComponent.prototype.addNewRule = function () {
        this.multiAutoRulesSet[this.setCount] = [{ variable: null, operator: null, value: '' }];
        this.setCount++;
    };
    RedeemCreateComponent.prototype.addRule = function (index) {
        var currentRule = this.multiAutoRulesSet[index];
        if (currentRule.length !== 0) {
            this.validateAndGenerateRules(index);
        }
        if (this.newRuleGenerated || currentRule.length === 0) {
            currentRule.push({ variable: null, operator: null, value: '' });
        }
    };
    RedeemCreateComponent.prototype.deleteRuleSet = function (index) {
        if (this.multiAutoRulesSet[index]) {
            delete this.multiAutoRulesSet[index];
            this.setCount--;
        }
        if (this.setCount === 0) {
            this.multiAutoRulesSet = {};
        }
        else {
            var tempSet = {};
            var tempCount = 0;
            for (var rule in this.multiAutoRulesSet) {
                if (this.multiAutoRulesSet[rule]) {
                    tempSet[tempCount] = this.multiAutoRulesSet[rule];
                    tempCount++;
                }
            }
            this.multiAutoRulesSet = tempSet;
        }
    };
    RedeemCreateComponent.prototype.removeRule = function (parentIndex, index) {
        if (this.multiAutoRulesSet[parentIndex] && this.multiAutoRulesSet[parentIndex].length > index) {
            var currentRuleSet = this.multiAutoRulesSet[parentIndex];
            var rules = [];
            var i = 0;
            for (var rul in currentRuleSet) {
                if (currentRuleSet.hasOwnProperty(rul)) {
                    if (i !== index) {
                        rules.push(currentRuleSet[rul]);
                    }
                    i++;
                }
            }
            if (rules.length) {
                this.multiAutoRulesSet[parentIndex] = rules;
            }
            else {
                this.deleteRuleSet(parentIndex);
            }
        }
    };
    RedeemCreateComponent.prototype.changeInVariable = function (parentIndex, index) {
        if (this.multiAutoRulesSet[parentIndex][index].variable === 'isFirstRedeem') {
            this.multiAutoRulesSet[parentIndex][index].operator = 'boolean';
        }
    };
    RedeemCreateComponent.prototype.isEmpty = function (value) {
        return (value == null || value.length === 0);
    };
    RedeemCreateComponent.prototype.isInt = function (n) {
        return Number(n) === n && n % 1 === 0;
    };
    RedeemCreateComponent.prototype.validateAndGenerateRules = function (index) {
        this.newRuleGenerated = false;
        var currentRule = this.multiAutoRulesSet[index];
        if (currentRule.length < 1) {
            this.errorMessage('You must add at least one rule for auto-approval');
        }
        var allFilled = false;
        var uniqueVariables = [];
        var variables = Object.keys(this.maxLimits);
        for (var x in currentRule) {
            if (currentRule.hasOwnProperty(x)) {
                if (uniqueVariables.indexOf(currentRule[x].variable) !== -1) {
                    this.errorMessage('You can use a variable only in one rule. There are more than one rules with the variable \''
                        + currentRule[x].variable + '\'');
                    return;
                }
                else {
                    uniqueVariables.push(currentRule[x].variable);
                }
                var i = parseInt(x, 10) + 1;
                if (!currentRule[x].variable) {
                    this.errorMessage('Please enter a variable for rule #' + i);
                    return;
                }
                else if (!currentRule[x].operator) {
                    this.errorMessage('Please enter an operator for rule #' + i);
                    return;
                }
                else if (this.isEmpty(currentRule[x].value)) {
                    this.errorMessage('Please enter a value for rule #' + i);
                    return;
                }
                else if (currentRule[x].value < 0) {
                    this.errorMessage('Please enter a positive value for rule #' + i);
                    return;
                }
                else if ((variables.indexOf(currentRule[x].variable) > -1 &&
                    currentRule[x].value > this.maxLimits[currentRule[x].variable]) ||
                    (currentRule[x].maxValue &&
                        currentRule[x].maxValue > this.maxLimits[currentRule[x].variable])) {
                    this.errorMessage("Max limit for " + currentRule[x].variable + " is " + this.maxLimits[currentRule[x].variable]);
                    return;
                }
                else {
                    allFilled = true;
                }
            }
        }
        if (allFilled) {
            this.checkAllRuleTypes(index);
        }
    };
    RedeemCreateComponent.prototype.checkAllRuleTypes = function (index) {
        var currentRule = this.multiAutoRulesSet[index];
        var checked = 0;
        for (var x in currentRule) {
            if (currentRule.hasOwnProperty(x)) {
                var i = parseInt(x, 10) + 1;
                if (currentRule[x].variable === 'redeemAmount' || currentRule[x].variable === 'totalKm') {
                    if (currentRule[x].value < 1) {
                        this.errorMessage('Enter a positive value (greater than 0) for rule #' + i);
                        return;
                    }
                    else {
                        checked++;
                    }
                }
                else if (currentRule[x].variable === 'numberOfOrders') {
                    if (!this.isInt(currentRule[x].value) || currentRule[x].value < 1) {
                        this.errorMessage('Enter an integer (without decimal) value, greater than 0 for rule #' + i);
                        return;
                    }
                    else {
                        checked++;
                    }
                }
                else if (currentRule[x].variable === 'isFirstRedeem') {
                    if (currentRule[x].value !== 'true' && currentRule[x].value !== 'false') {
                        this.errorMessage('The operator for isFirstRedeem must be T/F and must contain True or False as value');
                        return;
                    }
                    else {
                        checked++;
                    }
                }
                else {
                    checked++;
                }
                if (currentRule[x].operator === 'between') {
                    if (this.isEmpty(currentRule[x].value) || this.isEmpty(currentRule[x].maxValue)) {
                        this.errorMessage('You must enter both values for the \'between\' operator');
                        checked--;
                        return;
                    }
                    else if (currentRule[x].value > currentRule[x].maxValue || currentRule[x].value === currentRule[x].maxValue) {
                        this.errorMessage('The min value cannot be greater than or equal to the max value for the between operator');
                        checked--;
                        return;
                    }
                }
            }
        }
        if (checked === currentRule.length) {
            this.generateRule(index);
        }
        else {
            this.errorMessage('Something went wrong. Please check the rules again.');
            return;
        }
    };
    RedeemCreateComponent.prototype.generateRule = function (index) {
        var currentRule = this.multiAutoRulesSet[index];
        var tempRules = [];
        for (var x in currentRule) {
            if (currentRule[x].operator === 'between') {
                var str = currentRule[x].value + ' < ' + currentRule[x].variable + ' < ' + currentRule[x].maxValue;
                tempRules.push({ variable: currentRule[x].variable, condition: str, max: currentRule[x].maxValue, min: currentRule[x].value });
            }
            else if (currentRule[x].operator === 'boolean') {
                var str = currentRule[x].variable + ' == ' + currentRule[x].value;
                tempRules.push({ variable: currentRule[x].variable, condition: str });
            }
            else {
                var str = currentRule[x].variable + ' ' + currentRule[x].operator + ' ' + currentRule[x].value;
                tempRules.push({ variable: currentRule[x].variable, condition: str, max: currentRule[x].value, min: 0 });
            }
        }
        this.generatedRule[index] = tempRules;
        this.newRuleGenerated = true;
    };
    RedeemCreateComponent.prototype.generateMultiSetRules = function () {
        var allGood = true;
        for (var ruleSet in this.multiAutoRulesSet) {
            if (this.multiAutoRulesSet.hasOwnProperty(ruleSet)) {
                if (this.multiAutoRulesSet[ruleSet]) {
                    for (var rule in this.multiAutoRulesSet[ruleSet]) {
                        if (this.multiAutoRulesSet[ruleSet][rule]) {
                            var currentRule = this.multiAutoRulesSet[ruleSet][rule];
                            if (!currentRule.variable || !currentRule.operator || this.isEmpty(currentRule.value)) {
                                this.errorMessage('Please fill all the boxes for the rules or deleted unused rules');
                                allGood = false;
                                break;
                            }
                        }
                    }
                }
                if (allGood) {
                    this.validateAndGenerateRules(ruleSet);
                }
            }
        }
    };
    // ---- Edit reconstruction (ported verbatim from legacy) ----
    RedeemCreateComponent.prototype.getRuleDetails = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, rawTnc, tncText, city, err_4;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 7]);
                        return [4 /*yield*/, this.redeemService.getRule(id).toPromise()];
                    case 1:
                        response = _a.sent();
                        this.rule = response.data;
                        rawTnc = this.rule.tnc;
                        tncText = Array.isArray(rawTnc) ? rawTnc[0] : rawTnc;
                        if (typeof tncText === 'string' && tncText.trim() !== '') {
                            this.rule.tnc = tncText.split(/\r?\n/).join(';');
                        }
                        if (!(this.rule.cities && this.rule.cities.length)) return [3 /*break*/, 5];
                        city = this.cities.find(function (c) { return c.name === _this.rule.cities[0]; });
                        if (!city) return [3 /*break*/, 4];
                        this.selectedCity = city;
                        return [4 /*yield*/, this.fetchModesForCity(city.id)];
                    case 2:
                        _a.sent();
                        if (!this.rule.modeId) return [3 /*break*/, 4];
                        this.selectedMode = this.modes.find(function (m) { return String(m.id) === String(_this.rule.modeId); }) || null;
                        if (!this.selectedMode) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.fetchCaptainShifts(city.id, this.selectedMode.id)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        // Seed the shift options so any saved shifts render as selected.
                        this.shifts = Array.from(new Set((this.rule.shift || []).concat(this.shifts)));
                        _a.label = 5;
                    case 5:
                        this.blockRedeem = this.isShiftScoped
                            && (this.rule.blockRedeem === true || Number(this.rule.transactionCount) === 0);
                        this.tempRules = this.rule.multiAutoRedeemRules ? this.rule.multiAutoRedeemRules : {};
                        this.setCount = this.rule.multiAutoRedeemRules && Object.keys(this.rule.multiAutoRedeemRules)
                            ? Object.keys(this.rule.multiAutoRedeemRules).length : 0;
                        if (this.tempRules && Object.keys(this.tempRules).length) {
                            this.getAutomationRule();
                        }
                        else {
                            if (this.rule.automationRules && this.rule.automationRules.length) {
                                this.tempRules = { 0: this.rule.automationRules };
                                this.getAutomationRule();
                                this.setCount = 1;
                            }
                            else {
                                this.warningMessage('No auto-approval rules added for this rule.');
                            }
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        err_4 = _a.sent();
                        this.errorMessage(err_4 && err_4.info ? err_4.info.message : (err_4 && err_4.message) || 'Unable to fetch rule');
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    RedeemCreateComponent.prototype.getAutomationRule = function () {
        var _this = this;
        this.multiAutoRulesSet = {};
        var _loop_1 = function (ruleSet) {
            if (this_1.tempRules.hasOwnProperty(ruleSet)) {
                if (this_1.tempRules[ruleSet]) {
                    this_1.multiAutoRulesSet[ruleSet] = [];
                    this_1.tempRules[ruleSet].map(function (rule) {
                        var splitRule = rule.condition.split(' ');
                        if (splitRule.length === 3) {
                            if (splitRule[2] === 'true' || splitRule[2] === 'false') {
                                _this.multiAutoRulesSet[ruleSet].push({ variable: rule.variable, operator: 'boolean', value: splitRule[2] });
                            }
                            else {
                                _this.multiAutoRulesSet[ruleSet].push({ variable: rule.variable, operator: splitRule[1], value: parseFloat(splitRule[2]) });
                            }
                        }
                        if (splitRule.length === 5) {
                            _this.multiAutoRulesSet[ruleSet].push({ variable: rule.variable, operator: 'between', value: parseFloat(splitRule[0]), maxValue: parseFloat(splitRule[4]) });
                        }
                    });
                }
                this_1.validateAndGenerateRules(ruleSet);
            }
        };
        var this_1 = this;
        for (var ruleSet in this.tempRules) {
            _loop_1(ruleSet);
        }
    };
    Object.defineProperty(RedeemCreateComponent.prototype, "today", {
        // ---- Save (ported verbatim from legacy save validations) ----
        // Today's date as YYYY-MM-DD (matches the stored date format for lexical comparison).
        get: function () {
            var d = new Date();
            var mm = String(d.getMonth() + 1).padStart(2, '0');
            var dd = String(d.getDate()).padStart(2, '0');
            return d.getFullYear() + "-" + mm + "-" + dd;
        },
        enumerable: true,
        configurable: true
    });
    RedeemCreateComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var payload, selectedShifts, request, err_5;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.blockRedeem && !this.isShiftScoped) {
                            this.errorMessage('Block Redeem requires a city, mode and at least one shift');
                            return [2 /*return*/];
                        }
                        if (this.blockRedeem) {
                            this.applyBlockRedeemDefaults();
                        }
                        // City is required. Mode and Shift are optional (city-wide / city+mode / city+mode+shift).
                        if (!this.rule.cities || !Array.isArray(this.rule.cities) || this.rule.cities.length === 0) {
                            this.errorMessage('Must select at least one city');
                            return [2 /*return*/];
                        }
                        if (!this.rule.weekDays || !Array.isArray(this.rule.weekDays) || this.rule.weekDays.length === 0) {
                            this.errorMessage('Must select weekday(s)');
                            return [2 /*return*/];
                        }
                        if (!this.rule.transactionPeriod) {
                            this.errorMessage('Must select a type');
                            return [2 /*return*/];
                        }
                        if (!this.blockRedeem) {
                            if (!this.rule.transactionCount) {
                                this.errorMessage('Please enter No. of transactions');
                                return [2 /*return*/];
                            }
                            if (isNaN(this.rule.transactionCount) || this.rule.transactionCount < 1) {
                                this.errorMessage('No. of transactions must be a positive number (greater than 0)');
                                return [2 /*return*/];
                            }
                        }
                        if (!this.rule.minTransactionAmount) {
                            this.errorMessage('Please enter a minimum transaction amount');
                            return [2 /*return*/];
                        }
                        if (isNaN(this.rule.minTransactionAmount) || this.rule.minTransactionAmount < 1) {
                            this.errorMessage('Minimum transaction amount must be a positive number (greater than 0)');
                            return [2 /*return*/];
                        }
                        if (!this.rule.startDate) {
                            this.errorMessage('Must enter a start date');
                            return [2 /*return*/];
                        }
                        if (this.rule.startDate < this.today) {
                            this.errorMessage('Start date cannot be earlier than today');
                            return [2 /*return*/];
                        }
                        if (!this.rule.tnc) {
                            this.errorMessage('Please mention the terms and conditions');
                            return [2 /*return*/];
                        }
                        this.generatedRule = {};
                        if (this.blockRedeem) {
                            this.newRuleGenerated = true;
                        }
                        else if (this.multiAutoRulesSet && Object.keys(this.multiAutoRulesSet).length) {
                            this.generateMultiSetRules();
                        }
                        else {
                            this.errorMessage('Please add at least one auto-approval rule');
                            return [2 /*return*/];
                        }
                        if (!this.newRuleGenerated) {
                            return [2 /*return*/];
                        }
                        payload = tslib_1.__assign({}, this.rule);
                        payload.tnc = (this.rule.tnc + '').replace(/;/g, '\n');
                        payload.multiAutoRedeemRules = this.generatedRule;
                        payload.blockRedeem = this.blockRedeem;
                        // endDate is no longer part of redeem rules; never persist it (incl. when editing legacy rules).
                        delete payload.endDate;
                        selectedShifts = this.rule.shift || [];
                        if (selectedShifts.length > 0) {
                            payload.shift = selectedShifts;
                            if (this.selectedMode) {
                                payload.modeId = this.selectedMode.id;
                            }
                            else {
                                delete payload.modeId;
                            }
                        }
                        else if (this.selectedMode) {
                            payload.shift = [];
                            payload.modeId = this.selectedMode.id;
                        }
                        else {
                            payload.shift = [];
                            delete payload.modeId;
                        }
                        this.disableSubmit = true;
                        request = this.isEdit
                            ? this.redeemService.updateRule(this.ruleId, payload)
                            : this.redeemService.createRule(payload);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, request.toPromise()];
                    case 2:
                        _a.sent();
                        this.successMessage(this.isEdit ? 'Rule edited successfully.' : 'Rule added successfully.');
                        this.router.navigate(['/' + LIST_REDEEMS]);
                        return [3 /*break*/, 4];
                    case 3:
                        err_5 = _a.sent();
                        this.errorMessage(this.isEdit ? 'Unable to process.' : 'Unable to create rule.');
                        this.disableSubmit = false;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // ---- Toast helpers ----
    RedeemCreateComponent.prototype.errorMessage = function (message) {
        this.toasterService.showToaster(new Toaster({ type: ToasterType.WARNING, message: message }));
    };
    RedeemCreateComponent.prototype.successMessage = function (message) {
        this.toasterService.showToaster(new Toaster({ type: ToasterType.SUCCESS, message: message }));
    };
    RedeemCreateComponent.prototype.warningMessage = function (message) {
        this.toasterService.showToaster(new Toaster({ type: ToasterType.WARNING, message: message }));
    };
    return RedeemCreateComponent;
}());
export { RedeemCreateComponent };
